module.exports = __webpack_public_path__ + "img/imagemissing2.ab0b38c2.jpg";